import React from "react";
import { useNavigate } from "react-router-dom";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PercentIcon from "@mui/icons-material/Percent";
import DashboardIcon from "@mui/icons-material/Dashboard";

import PageContainer from "components/templates/PageContainer";

const Reports = () => {
  const navigate = useNavigate();

  const handleClickLocationOccupation = () =>
    navigate("/relatorio-local-ocupacao");
  const handleClickDensity = () => navigate("/relatorio-local-densidade");
  const handleClickLocationHourWeek = () =>
    navigate("/relatorio-local-hora-semana");
  const handleClickWeekReservation = () =>
    navigate("/relatorio-reserva-semana");

  return (
    <PageContainer maxWidth="lg" title={"Relatórios"} icon={<DashboardIcon />}>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={handleClickDensity}>
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText primary="Locais ocupados por Departamento" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleClickLocationHourWeek}>
              <ListItemIcon>
                <AccessTimeIcon />
              </ListItemIcon>
              <ListItemText primary="Carga Horária Diária do Local" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleClickLocationOccupation}>
              <ListItemIcon>
                <PercentIcon />
              </ListItemIcon>
              <ListItemText primary="Ocupação dos Locais" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleClickWeekReservation}>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="Programação semanal" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </PageContainer>
  );
};

export default Reports;
